export const TECHNICAL_TABLE_SURFACE_SX = {
  width: "100%",
  maxWidth: "100%",
  p: 2,
  overflow: "hidden",
  border: "1px solid var(--border-light)",
  borderRadius: "6px",
  boxShadow: "none",
  backgroundColor: "var(--bg-card)",
};

export const TECHNICAL_TABLE_SCROLL_SURFACE_SX = {
  ...TECHNICAL_TABLE_SURFACE_SX,
  overflow: "auto",
};
